import Api from '../api';
import { isEmpty as _isEmpty, map as _map } from 'lodash-es';
import { t } from 'i18next';

export default class ChartApi extends Api {
  getDashboardChartQueries = async () => {
    try {
      const apiData = await this.get(`chart_query/`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };

  getDashboardConfig = async props => {
    try {
      let appliedDashboardType = _map(props, type => type.toLowerCase()).join();
      if (_isEmpty(appliedDashboardType)) appliedDashboardType = 'd2c';
      const apiData = await this.get(`dashboard_config/?type=${appliedDashboardType}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_GET_DASHBOARD_CHART_QUERIES_GRAAS')
      };
    }
  };

  getHistoricalStatusConfig = async props => {
    try {
      let nickNameIDList = _map(props, type => type).join();
      const apiData = await this.get(`services/historicalDataJob?nickNameID=${nickNameIDList}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_GET_HISTORICAL_JOB_STATUS_DATA_GRAAS')
      };
    }
  };
}
